module.exports = __webpack_public_path__ + "img/help.9c883e59.svg";